// components/RemoteExperiencePopup.js
import React from "react";
import "../styles/RemoteExperiencePopup.css";

const RemoteExperiencePopup = ({ isOpen, onClose }) => {
    if (!isOpen) return null;

    return (
        <div className="popup-overlay">
            <div className="popup-content">
                <h2>💻 원격 체험 안내</h2>
                <p>
                    원격 체험은 고객님의 PC에 직접 접속하여 <strong>상품의 기능을 체험</strong>할 수 있게 돕는 기능입니다.<br />
                    <br />
                    저희는 <strong>구글 원격 데스크톱</strong>을 통해 안전하게 원격 체험을 진행하며,<br />
                    설치가 어려우신 분들도 <strong>간편한 링크 클릭</strong>만으로 접속이 가능합니다.
                </p>

                <h3>📌 원격 체험 진행 순서</h3>
                <ol>
                    <li>아래 링크를 클릭하여 <strong>구글 원격 데스크톱</strong>을 엽니다.</li>
                    <li>"내 컴퓨터 공유" 항목에서 코드를 생성합니다.</li>
                    <li>생성된 코드를 저희 상담원에게 전달해 주세요.</li>
                    <li>상담원이 접속하여 기능을 안내해드립니다.</li>
                </ol>

                <a
                    href="https://remotedesktop.google.com/support"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="remote-link"
                >
                    🔗 원격 체험 시작하기 (Google Remote Desktop)
                </a>

                <img
                    src="/images/remote-desktop-guide.png"
                    alt="구글 원격 데스크톱 사용법"
                    className="remote-guide-img"
                />

                <button onClick={onClose} className="close-btn">닫기</button>
            </div>
        </div>
    );
};

export default RemoteExperiencePopup;
